exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container[data-v-1c024fd2]{margin-top:10px}.delete[data-v-1c024fd2]{position:absolute;right:25px;top:80px}img[data-v-1c024fd2]{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1c024fd2","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/app/components/EditQuestion.vue
// module id = 0Zio
// module chunks = 0